import InstantSurveyApi from '@api/instant_survey/api';
import { Error } from '@utilities';

const SurveyNetworkError = () => {
  const endpoint = InstantSurveyApi.defaults.baseURL?.replace(/^(https?:|)\/\//, '');

  return (
    <Error
      description={
        <>
          Apologies, but it looks like we&apos;re having difficulty reaching our Survey service.{' '}
          {endpoint ? (
            <>
              If applicable, ensure <strong>{endpoint}</strong> is whitelisted on your network.
              Otherwise, please contact your consultant.
            </>
          ) : (
            <>Please contact your consultant for assistance.</>
          )}
        </>
      }
      header="Service Unavailable"
      status={404}
    />
  );
};

export default SurveyNetworkError;
